import React from 'react';
import { Link } from 'react-router-dom';


export default function NavBar() {
  
 
    return(

      <Link to="/" >

        <div className="rocket-cont">

            <p className="rocket-bar">Go Home</p>
        </div>
      </Link>
      
         

    );
    
    
}